<template>
  <div>
    <FilterOverview title="Airlines" :showFilterInitially="false">
      <template #table="{ tableHeight }">
        <b-overlay :show="isLoading">
          <div
            class="p-6 card card-body"
            style="min-width: 900px; overflow: auto"
            :style="{ height: tableHeight + 87 + 'px' }"
          >
            <AddRemoveButton
              v-if="isAuthorized"
              v-b-modal.modalAirlineErstellen
              v-b-tooltip.hover.bottom
              title="Airline hinzufügen"
            />
            <div
              v-for="airline in airline"
              :key="airline.airlineKuerzel"
              class="mt-4 d-flex align-items-center"
              style="gap: 12px"
            >
              <b-form-group label="Airline">
                <h6 class="mb-0" style="width: 150px">{{ airline.airlineKuerzel }}</h6>
              </b-form-group>
              <b-form-group label="Optionsfrist">
                <b-form-input
                  v-model="airline.optionsfrist"
                  @update="changeOptionsfrist(airline.optionsfrist, airline.airlineKuerzel)"
                  debounce="500"
                  type="number"
                  style="width: 150px"
                  :disabled="!isAuthorized"
                />
              </b-form-group>
              <b-form-group label="Ticketfrist">
                <b-form-input
                  v-model="airline.ticketingfrist"
                  @update="changeTicketingfrist(airline.ticketingfrist, airline.airlineKuerzel)"
                  debounce="500"
                  type="number"
                  style="width: 150px"
                  :disabled="!isAuthorized"
                />
              </b-form-group>
              <div
                v-if="isAuthorized"
                class="ml-2"
                @click="onClickDeleteAirline(airline.airlineKuerzel)"
                style="cursor: pointer"
              >
                <Trash2 :size="16" style="color: black" />
              </div>
            </div>
          </div>
        </b-overlay>
      </template>
    </FilterOverview>
    <AirlineErstellenModal @airlineErstellt="onAirlineErstellt" />
    <DeleteConfirmationModal
      id="modalAirlineLoeschen"
      title="Airline löschen?"
      entityBezeichnung="die Airline"
      :label="pendingDeleteAirlineKuerzel"
      @confirm="confirmDeleteAirline"
    />
  </div>
</template>

<script>
import FilterOverview from '@/components/common/filter-overview.vue';
import AirlineErstellenModal from '@/components/modals/airline-erstellen.vue';
import DeleteConfirmationModal from '@/components/common/delete-confirmation-modal.vue';
import apiService from '@/core/common/services/api.service';
import { Role } from '@/core/user/roles';
import { Trash2 } from 'lucide-vue';
import AddRemoveButton from '@/components/common/add-remove-button.vue';

export default {
  components: {
    AddRemoveButton,
    FilterOverview,
    AirlineErstellenModal,
    DeleteConfirmationModal,
    Trash2,
  },
  data() {
    return {
      airline: [],
      isLoading: false,
      // Zwischengespeichertes Kürzel der zu löschenden Airline für den Bestätigungsdialog
      pendingDeleteAirlineKuerzel: null,
    };
  },
  computed: {
    isAuthorized() {
      const roles = this.$store.getters.customRoles || this.$store.getters.parsedRoles;
      const currentUserId = this.$store.getters.currentUser?.localAccountId;
      const authorizedUsers = [
        '61ca51a5-ee49-4bd9-83a4-2e7f7f2ac67b',
        '0628f85f-b927-4faa-a6ff-aa09c07164de',
      ];

      if (roles.includes(Role.ADMIN)) {
        return true;
      }

      if (authorizedUsers.includes(currentUserId)) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    this.loadAirlines();
  },
  methods: {
    loadAirlines() {
      this.isLoading = true;
      apiService
        .get('/airline')
        .then(result => {
          this.airline = result.data.result;
        })
        .finally(() => (this.isLoading = false));
    },
    onAirlineErstellt() {
      this.loadAirlines();
    },
    deleteAirline(airlineKuerzel) {
      this.isLoading = true;
      apiService
        .delete('/airline/' + airlineKuerzel)
        .then(() => {
          this.loadAirlines();
          this.toast(`Airline: ${airlineKuerzel} erfolgreich gelöscht.`);
        })
        .finally(() => (this.isLoading = false));
    },
    changeOptionsfrist(optionsfrist, airlineKuerzel) {
      this.isLoading = true;
      apiService
        .put('/airline/' + airlineKuerzel, { optionsfrist })
        .then(() => {
          this.loadAirlines();
          this.toast(`Airline: ${airlineKuerzel} erfolgreich geändert.`);
        })
        .finally(() => (this.isLoading = false));
    },
    changeTicketingfrist(ticketingfrist, airlineKuerzel) {
      this.isLoading = true;
      apiService
        .put('/airline/' + airlineKuerzel, { ticketingfrist })
        .then(() => {
          this.loadAirlines();
          this.toast(`Airline: ${airlineKuerzel} erfolgreich geändert.`);
        })
        .finally(() => (this.isLoading = false));
    },
    onClickDeleteAirline(airlineKuerzel) {
      // Kürzel merken und Bestätigungsdialog öffnen
      this.pendingDeleteAirlineKuerzel = airlineKuerzel;
      this.$bvModal.show('modalAirlineLoeschen');
    },
    confirmDeleteAirline() {
      const airlineKuerzel = this.pendingDeleteAirlineKuerzel;
      this.$bvModal.hide('modalAirlineLoeschen');
      if (!airlineKuerzel) return;
      this.deleteAirline(airlineKuerzel);
      this.pendingDeleteAirlineKuerzel = null;
    },
  },
};
</script>
